import dotProp from 'dot-prop-immutable-chain'

import {
  FETCH_ALL_EVENT_TEMPLATES_ASYNC_END,
  FETCH_ALL_EVENT_TEMPLATES_ASYNC_START,
  FETCH_ALL_EVENT_TEMPLATES_SUCCESS,
} from '../actions/actions'

/**
 * eventTemplates reducer
 *
 * @param {State} state
 *
 * @param {Object} action
 * @param {Array} action.badges
 * @param {Array} action.certificates
 * @param {Array} action.appreciationLetters
 */
export default function eventTemplates(state = {}, action) {
  switch (action.type) {
    case FETCH_ALL_EVENT_TEMPLATES_ASYNC_START:
      return dotProp(state)
        .set('isLoading', true)
        .value()

    case FETCH_ALL_EVENT_TEMPLATES_ASYNC_END:
      return dotProp(state)
        .set('isLoading', false)
        .value()

    case FETCH_ALL_EVENT_TEMPLATES_SUCCESS:
      return dotProp(state)
        .set('badges', action.badges)
        .set('certificates', action.certificates)
        .set('appreciations', action.appreciationLetters)
        .value()

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/eventTemplates.js